module.exports = __webpack_public_path__ + "static/media/support_07.2dbaab3c.png";